import React from 'react';

import ThemeSelector from '../../themes/theme-selector';

const PoweredByDyzio = () => {
  const isWhiteLabel = ThemeSelector.isWhiteLabel();
  const isFullWhiteLabel = ThemeSelector.isFullWhiteLabel();

  // Full white label doesn't mention dyzio
  // i.e. app.voxogram.com
  if (isFullWhiteLabel) return null;

  // partial white label shows powered by dyzio
  if (isWhiteLabel) {
    return (
      <table style={{ margin: '0 auto' }}>
        <tr>
          <td>
            <h3>powered by&nbsp;</h3>
          </td>
          <td>
            <img src="/dyzio-logo.png" alt="dyzio beta" style={{ height: '50px' }} />
          </td>
        </tr>
      </table>
    );
  }

  return null;
};

export default PoweredByDyzio;



/** WEBPACK FOOTER **
 ** ./src/components/powered-by-dyzio/index.js
 **/